import React from 'react';
import { Alert, Col, Row } from 'react-bootstrap';
import Image from 'next/image';
import askIcon from '@/public/images/icons/notifications/ask.svg';
import { toDe } from '@/utilites/sku-operations';
import { SkuIsAskOwnerProps } from '@/types/props/components/skus';
import { SkuEnum } from '@/types/translations/SkuEnum';
import useTypedTranslation from '@/hooks/useTypedTranslation';

const SkuIsAskOwnerDesktop = ({ isAskOwner, askValue }: SkuIsAskOwnerProps) => {
  const { translate } = useTypedTranslation<SkuEnum>('sku');

  if (!isAskOwner) return null;
  return (
    <Alert variant="" className="bg-light bg-opacity-50 rounded-15 mb-5">
      <Row className="align-items-center">
        <Col md="auto">
          <Image src={askIcon} alt="Ask Icon" width={40} height={40} />
        </Col>
        <Col>
          <p className="mb-0 fw-bold">
            {translate(SkuEnum['your_current_ask_for_this_item_is'])}{' '}
            {toDe(askValue)}
          </p>
        </Col>
      </Row>
    </Alert>
  );
};

export default SkuIsAskOwnerDesktop;
